module.exports = __webpack_public_path__ + "static/media/button_providers.ced174c8.png";